import { render, staticRenderFns } from "./SidebarCartItem.vue?vue&type=template&id=c83949da&"
import script from "./SidebarCartItem.vue?vue&type=script&lang=js&"
export * from "./SidebarCartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports